<template>
    <div class="module-toggle-group">
        <div 
            class="toggle-all" 
            :class="{'active': isActive}"
            @click.stop="toggle"
            :title="title"
        >
            <span class="material-icons">{{ getIcon }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModuleToggle',
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        isPartial: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: 'Tüm izinleri etkinleştir/kaldır'
        }
    },
    computed: {
        getIcon() {
            if (this.isActive) return 'check_circle';
            if (this.isPartial) return 'radio_button_checked';
            return 'radio_button_unchecked';
        }
    },
    methods: {
        toggle() {
            this.$emit('toggle');
        }
    }
}
</script>

<style lang="scss" scoped>
.module-toggle-group {
    display: flex;
    margin-right: 12px;
    user-select: none;
    
    & > div {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-left: 6px;
        border-radius: 4px;
        transition: all 0.2s;
        
        &:hover {
            background-color: #f5f5f5;
        }
        
        span {
            font-size: 16px;
        }
    }
    
    .toggle-all {
        color: #999;
        
        &:hover {
            color: #666;
        }
        
        &.active {
            color: #4caf50;
            
            &:hover {
                color: #388e3c;
            }
        }
    }
}
</style> 